import React from 'react';
import { object } from 'prop-types';
import RecipeListContainer from '../../../containers/RecipeListContainer';
import QuizListContainer from '../../../containers/QuizListContainer';
import Loading from '../../atoms/Loading/index';
import SingleContentLayout from '../../templates/SingleContentLayout';
import RecipeAndQuizLayout from '../../templates/RecipeAndQuizLayout';
import RecipeLayout from '../../templates/RecipeLayout';
import CreateQuizModalContainer from '../../../containers/CreateQuizModalContainer';
import { REQUESTING, ROUTES } from '../../../constants';

const CreateQuizPage = ({ createQuiz, location }) => {
	const { fetchingState: fetchingStateRecipes, error } = createQuiz;
	const { type } = location;
	if (fetchingStateRecipes === REQUESTING.FAIL) {
		return error;
	}
	if (fetchingStateRecipes !== REQUESTING.LOADED) {
		return <RecipeLayout
			render={() => <RecipeListContainer />}
		/>;
	}
	if (type === ROUTES.SHOW_RECIPE ||
		type === ROUTES.REQUEST_QUIZ_EDITOR) {
		return <React.Fragment>
			<CreateQuizModalContainer />
			<RecipeAndQuizLayout
				renderLeft={() => <RecipeListContainer />}
				renderRight={() => <QuizListContainer />}
			/>
		</React.Fragment>;
	}
	if (type === ROUTES.CREATE_QUIZ_SELECTED) {
		return <RecipeLayout
			render={() => <RecipeListContainer />}
		/>;
	}
	return <SingleContentLayout
		render={() => <Loading />}
	/>;
};

CreateQuizPage.propTypes = {
	createQuiz: object.isRequired,
	recipeReducer: object.isRequired,
	location: object.isRequired
};

export default CreateQuizPage;